<template>
  <section class="wrapper download_page faq">
    <h1>{{ $isPcBeatDayShow ? $t('faq.key004') : $t('faq.key007') }}</h1>
    <div class="block">
      <!-- PCBeatDay 區塊 -->
      <template v-if="$isPcBeatDayShow">
        <h2>{{ $t('redemption-guide.key001') }}</h2>
        <br />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_PC.png`" alt="" />
        <br /><br />
        <h2>{{ $t('redemption-guide.key002') }}</h2>
        <br />
      </template>

      <img v-if="$isPcBeatDayShow" :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_Web.png`" alt="" />
      <template v-else-if="isMobile">
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_Mobile_1.jpg`" alt="" />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_Mobile_2.jpg`" alt="" />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_Mobile_3.jpg`" alt="" />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_Mobile_4.jpg`" alt="" />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_Mobile_5.jpg`" alt="" />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_Mobile_6.jpg`" alt="" />
      </template>
      <template v-else>
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_PC_1.jpg`" alt="" />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_PC_2.jpg`" alt="" />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_PC_3.jpg`" alt="" />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_PC_4.jpg`" alt="" />
        <img :src="`${$cloudFront}/Image/Public/faq/redemptionGuide/${currentLanguage}/redemptionGuide_PC_5.jpg`" alt="" />
      </template>
    </div>
  </section>
</template>
<script>
export default {
  name: 'FAQ',
  components: {},
  mounted() {},
  data() {
    return {};
  },
  props: {},
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {},
};
</script>

<style lang="scss"></style>
